/* eslint-disable import/order */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { GlobalFooterModule } from '@delon/abc/global-footer';
import { NoticeIconModule } from '@delon/abc/notice-icon';
import { LayoutDefaultModule } from '@delon/theme/layout-default';
import { SettingDrawerModule } from '@delon/theme/setting-drawer';
import { ThemeBtnModule } from '@delon/theme/theme-btn';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';

import { LayoutBasicComponent } from './basic/basic.component';
import { HeaderClearStorageComponent } from './basic/widgets/clear-storage.component';
import { HeaderFullScreenComponent } from './basic/widgets/fullscreen.component';

import { HeaderQuinnyAIComponent } from './basic/widgets/quinny-ai/quinny-ai.component';
import { HeaderSearchComponent } from './basic/widgets/search.component';
import { HeaderUserComponent } from './basic/widgets/user.component';
import { HeaderMobileDropdownNavComponent } from './basic/widgets/mobile-dropdown-nav.component';
import { LayoutBlankComponent } from './blank/blank.component';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { PromptCardRunnerComponent } from './basic/widgets/prompt-card-runner/prompt-card-runner.component';

// passport
import { LayoutPassportComponent } from './passport/passport.component';
import { HeaderSupportComponent } from './basic/widgets/support.component';
import { HeaderHowToComponent } from './basic/widgets/how-to/how-to.component';
import { ReuseTabModule } from '@delon/abc/reuse-tab';
import { HeaderNotifyComponent } from './basic/widgets/notify/notify.component';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { HeaderTourComponent } from './basic/widgets/tour.component';
import {
  SpeechRecognitionService,
  SpeechSynthesisModule
} from '@ng-web-apis/speech';
import { HeaderFinancialAdvisorComponent } from './basic/widgets/financial-advisor/financial-advisor.component';
import { SharedModule } from '../shared/shared.module';
import { NzResultModule } from 'ng-zorro-antd/result';
import { InitSampleComponent } from './basic/widgets/init-sample/init-sample.component';
import { LicenseNotificationComponent } from './basic/widgets/license-notification/license-notification.component';
import { HeaderMarketplaceComponent } from './basic/widgets/marketplace.component';
import { GlobalLicenseNotificationComponent } from './basic/widgets/global-license-notification/global-license-notification.component';
import { MfaPromptComponent } from './basic/widgets/mfa-prompt/mfa-prompt.component';
import { NotificationIconComponent } from './basic/widgets/notify/components/notification-icon/notification-icon.component';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { AppNavComponent } from './basic/nav/nav.component';
import { MobileAppQrCodeComponent } from './basic/widgets/mobile-app-qr-code/mobile-app-qr-code.component';
import { EinvWizardAutoPlayComponent } from './basic/widgets/einv-wizard.component';
import { HeaderChatbotComponent } from './basic/widgets/chatbot/chatbot.component';
import { FcwidgetComponent } from './basic/widgets/fcwidget/fcwidget.component';
import { QBotReportAnalyzerComponent } from '../shared-feature/components/ai-widgets/q-bot-report-analyzer/q-bot-report-analyzer.component';
import { PremiumFeatureModalComponent } from '../shared-feature/components/ai-widgets/premium-feature-modal/premium-feature-modal.component';
import { KeyboardShortcutsDirective } from '../shared/directives/keyboard-shortcuts.directive';
import {
  FinancialRatioLangSelectionComponent
} from '@shared-feature/components/financial-ratio-lang-selection/financial-ratio-lang-selection.component';
import { PageHowToComponent } from '../shared-feature/components/page-how-to/page-how-to.component';
import { HeaderCompanyWidgetComponent } from './basic/widgets/header-company-widget/header-company-widget.component';
import { UserTermsComponent } from '../routes/passport/user-terms/user-terms.component';
import { TrialBannerComponent } from './basic/widgets/trial-banner/trial-banner.component';
import { NzCollapseComponent, NzCollapsePanelComponent } from 'ng-zorro-antd/collapse';
import { N3BannerComponent } from './passport/n3-banner/n3-banner.component';

const STANDALONE_COMPONENTS = [
  AppNavComponent,
  LayoutBasicComponent,
  LayoutBlankComponent,
  HeaderFinancialAdvisorComponent,
  LicenseNotificationComponent,
  GlobalLicenseNotificationComponent,
  InitSampleComponent,
  EinvWizardAutoPlayComponent,
  HeaderSearchComponent,
  HeaderFullScreenComponent,
  HeaderClearStorageComponent,
  HeaderUserComponent,
  HeaderQuinnyAIComponent,
  HeaderHowToComponent,
  HeaderSupportComponent,
  HeaderNotifyComponent,
  HeaderMobileDropdownNavComponent,
  HeaderTourComponent,
  HeaderMarketplaceComponent,
  LayoutPassportComponent,
  NotificationIconComponent,
  MobileAppQrCodeComponent,
  HeaderChatbotComponent,
  FcwidgetComponent,
  QBotReportAnalyzerComponent,
  PremiumFeatureModalComponent,
  KeyboardShortcutsDirective,
  FinancialRatioLangSelectionComponent,
  MfaPromptComponent,
  PromptCardRunnerComponent,
  HeaderCompanyWidgetComponent,
  UserTermsComponent,
  TrialBannerComponent,
  N3BannerComponent,
  PageHowToComponent
];

@NgModule({
  declarations: [],
  providers: [SpeechRecognitionService],
  exports: [
    LayoutBasicComponent,
    LayoutBlankComponent,
    LayoutPassportComponent,
    HeaderFinancialAdvisorComponent,
    LicenseNotificationComponent,
    GlobalLicenseNotificationComponent,
    InitSampleComponent,
    EinvWizardAutoPlayComponent,
    AppNavComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ThemeBtnModule,
    NzResultModule,
    SettingDrawerModule,
    LayoutDefaultModule,
    NoticeIconModule,
    GlobalFooterModule,
    NzDropDownModule,
    NzInputModule,
    NzAutocompleteModule,
    NzGridModule,
    NzFormModule,
    NzSpinModule,
    NzBadgeModule,
    NzAvatarModule,
    NzIconModule,
    NzToolTipModule,
    NzDividerModule,
    NzTagModule,
    NzProgressModule,
    NzDrawerModule,
    ReuseTabModule,
    NzTypographyModule,
    NzTabsModule,
    SpeechSynthesisModule,
    SharedModule,
    NzMenuModule,
    NzCollapseComponent,
    NzCollapsePanelComponent,
    ...STANDALONE_COMPONENTS
  ]
})
export class LayoutModule {}
